export default __webpack_public_path__ + "static/media/ContestRank3.86cd7d6b.svg";